import React from "react";

import { DropzoneOptions, useDropzone } from "react-dropzone";
import { Noop } from "react-hook-form";

import { toFileList } from "@/utils/file";
import { maybeCall } from "@/utils/functions";

interface Props extends DropzoneOptions {
  className?: string;
  children?: (browseFile: () => void) => React.ReactNode;
  onChange?: (...event: any[]) => void;
  onBlur?: Noop;
  name?: string;
}

/**
 * To be used inside forms with react-hook-form only. Use the normal
 * `useDropzone` or `Dropzone` component from "react-dropzone" for other cases.
 */
const DropzoneInput = React.forwardRef<HTMLInputElement, Props>(
  ({ className, children, onChange, onBlur, name, ...dropzoneProps }, ref) => {
    // Default of dropzone is multiple files
    const multiple = dropzoneProps.multiple ?? true;

    const { getRootProps, getInputProps, open } = useDropzone({
      ...dropzoneProps,
      onDrop: (acceptedFiles) => {
        maybeCall(
          onChange,
          multiple ? toFileList(acceptedFiles) : acceptedFiles[0]
        );
      },
    });

    return (
      <div {...getRootProps({ className: className })}>
        <input {...getInputProps({ onChange, onBlur, name })} ref={ref} />
        {maybeCall(children, open)}
      </div>
    );
  }
);

export default DropzoneInput;
